import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './CountryRisk.scss';
import { withTranslation } from 'react-i18next';
import { Button, Form, Table } from 'react-bootstrap';
import nodataimg from '../../../images/nodatafound.png';
import { DEFAULT_ITEMS_PER_PAGE, LIST_DEF_SORT, SORT_ORDER_DESC, startYear, currentYear } from '../../../core/constants/common';
import Pagination from "../../../components/Pagination/Pagination";
import CountryRiskService from '../../../core/service/CountryRiskService';
import Utils from '../../../core/utilities/Utils';
import { RegulationContext } from '../../../App';
import { toast } from "react-toastify";
import { FcFinePrint } from "react-icons/fc";

import { Link } from 'react-router-dom';
import { BiSearch } from 'react-icons/bi';
const CountryRisk = ({ t }) => {
  const [maintabledata, setMainTableData] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeonly, setActiveOnly] = useState(false);
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [countryscores, setCountryScores] = useState([]);
  var lsDat = JSON.parse(localStorage.getItem("authority"));
  // const navigate = useNavigate();
  const companyId = lsDat.profile.company.id;
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const [frequency, setFrequency] = useState("");
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [frequencymonth, setFrequencyMonth] = useState('04');
  useEffect(() => {
    if (glbRegulationId) {

      setFrequency(glbRegulation.frequency);
      let month = '01';
      switch (glbRegulation.frequency) {
        case 'ANNUAL':
        case 'QUARTERLY':
        case 'HALF_YEARLY':
        case 'MONTHLY':
          month = '01';
          setFrequencyMonth('01');
          break;
        case 'FINANCIAL_YEAR':
          month = '04';
          setFrequencyMonth('04');
          break;
        default:
          break;
      }
      getMainTableList(0, itemsPerPage, glbRegulation.frequency, annualyear, month, key);
    }
  }, [glbRegulationId]);

  const updateFieldChanged = (index) => (e) => {
    const newArr = countryscores.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    // console.log('newArr',newArr)
    setCountryScores(newArr);
  };
  const getMainTableList = (pageNumber, itemsPerPageVal, frequencyDat, year, month, sKey) => {
    setMainTableData('');
    var string = Utils.generateUrlParamCompanyRegulation(companyId, glbRegulationId);
    var encodedDat = Utils.encodeBase64(string);
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }

    let frequencyParam = year + '-' + month + '-01';
    CountryRiskService.getList(encodedDat, frequencyParam, pageNumber, perPage, sKey)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setMainTableData([...response.data]);
        let arrayData = [];
        for (let i = 0; i < response.data.length; i++) {
          let iterate = response.data[i];
          let obj = {
            id: iterate.id,
            country: {
              id: iterate.country.id
            },
            score: iterate.score
          }
          if (iterate.score != null) {
            obj['score'] = iterate.score
          } else {
            obj['score'] = 0;
          }
          arrayData.push(obj)
        }
        setCountryScores(arrayData);
        console.log(response.data, arrayData);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };

  const submitData = async (e) => {
    var objBody = {
      countryScores: countryscores,
    };


    var string = Utils.generateUrlParamCompanyRegulation(companyId, glbRegulationId);
    var encodedDat = Utils.encodeBase64(string);


    // return
    let frequencyParam = annualyear + '-' + frequencymonth + '-01';
    CountryRiskService.saveData(encodedDat, frequencyParam, objBody)
      .then((response) => {
        // console.log("response", response);
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        //console.log("error", error);
        //ErrorHandlingService.handleError(error.response.status);
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const renderSwitch = () => {
    const options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push(<option value={i} key={i}>{i}</option>);
    }
    switch (frequency) {
      case 'ANNUAL':
        return <div> <select
          className="form-select"
          required
          onChange={(e) => {
            setAnnualYear(e.target.value);
            getMainTableList(0, itemsPerPage, frequency, e.target.value, frequencymonth, key);
          }}
          value={annualyear}>
          {/* <option value="">{t("Select.label")}</option> */}
          {options}
        </select></div>;
      case 'FINANCIAL_YEAR':
        return <div className="col-md-12">
          <select
            className="form-select col-md-6"
            required
            onChange={(e) => {
              setAnnualYear(e.target.value);
              setFrequencyMonth('04');
              getMainTableList(0, itemsPerPage, frequency, e.target.value, '04', key);
            }}
            value={annualyear}>
            {/* <option value="">{t("Select.label")}</option> */}
            <option value="2021">2021(APRIL)</option>
            <option value="2022">2022(APRIL)</option>
          </select>

          {/* <select
            className="form-select col-md-6"
            required
            onChange={(e) => {
              setFrequencyMonth(e.target.value);
              getMainTableList(0, itemsPerPage, frequency,annualyear, e.target.value,key);
            }}
            value={frequencymonth}>
            <option value="">{t("Select.label")}</option>
            <option value="01">JAN-DEC</option>
            <option value="04">APR-MAR</option>
          </select> */}

        </div>;
      case 'QUARTERLY':
        return <div className="d-flex ">
          <div className='p-1'>
            <select
              className="form-select"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                // getSuplierData(regulationId ,frequency, e.target.value,decodedObj.supplier.id, null);
              }}
              value={annualyear}>
              {/* <option value="">{t("Select.label")}</option> */}
              <option value="2021">2021</option>
              <option value="2022">2022</option>
            </select>
          </div>
          <div className='p-1'>
            <select
              className="form-select"
              required
              onChange={(e) => {
                setFrequencyMonth(e.target.value);
                getMainTableList(0, itemsPerPage, frequency, annualyear, e.target.value, key);
              }}
              value={frequencymonth}>
              {/* <option value="">{t("Select.label")}</option> */}
              <option value="01">Q1</option>
              <option value="04">Q2</option>
              <option value="07">Q3</option>
              <option value="10">Q4</option>
            </select>
          </div>

        </div>;
      case 'HALF_YEARLY':
        return <div className="d-flex">
          <div className='p-1'>
            <select
              className="form-select "
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
              }}
              value={annualyear}>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
            </select>
          </div>

          <div className='p-1'>
            <select
              className="form-select "
              required
              onChange={(e) => {
                setFrequencyMonth(e.target.value);
                getMainTableList(0, itemsPerPage, frequency, annualyear, e.target.value, key);
              }}
              value={frequencymonth}>
              <option value="01">JAN-JUN</option>
              <option value="07">JUL-DEC</option>
            </select>
          </div>

        </div>;
      default:
        return '';
    }
  };
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getMainTableList(0, itemsPerPage, frequency, annualyear, frequencymonth, e.target.value);
  };
  return (
    <div className="SupplierList">
      <div className="List_header">
        <h5 className="MH">{t("Countries.label")}</h5>

        <div className="List_sorts_menu">
          {/* <ul>
              <li>
                <Button variant="primary" onClick={handleShow}>
                  {t("AddNew.label")}
                </Button>
              </li>
            </ul> */}
        </div>
      </div>


      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            {renderSwitch()}
            {/* <div className='List_table-card_Search_Box'>
              <Form>
              <input
                type="text"
                className="form-control"
                onChange={handleSearch}
                placeholder={t("Search.label")}
              />
              <Link to="#" className="Search_iocnBox">
                <BiSearch />
              </Link>
            </Form>
              </div> */}

          </div>
          <div className="List_table-card01_sort">
            <button
              type="button"
              onClick={() => {
                submitData();
              }}
              className="btn btn-primary ms-2 px-4 btn-color sbmBtn"
            >
              {t("Save.label")}
            </button>

          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                {/* <th>
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th> */}
                <th>{t("country.label")}</th>
                <th>{t("CountryCode.label")}</th>
                <th>{t("RiskScore.label")}</th>
              </tr>
            </thead>
            {(maintabledata === undefined || maintabledata == null || maintabledata.length === 0) &&
              <tbody>
                <tr>
                  <td colSpan="3" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            }
            {maintabledata && maintabledata !== undefined && maintabledata.length > 0 &&
              <tbody>
                {maintabledata?.map((item, index) => (
                  <tr key={item.id}>
                    {/* <td className="checkbox">
                      {" "}
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id="inline-checkbox-1"
                      />
                    </td> */}
                    <td>{item.country.name}</td>
                    <td>
                      {item.country.code}
                    </td>
                    <td>
                      <div>
                        <input className='form-control w-auto'
                          value={countryscores[index].score}
                          name="score"
                          onChange={updateFieldChanged(index)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}

              </tbody>
            }
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, glbRegulation.frequency, annualyear, frequencymonth, key);
                // getMainTableList(pageNum, perPage, key, sortField,activeonly);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default withTranslation()(CountryRisk);
